import React from 'react';
export function CategoryChip({
  label,
  className = ''
}: {
  label: string;
  className?: string;
}) {
  return <span className={`inline-flex rounded-full bg-brand-soft px-2.5 py-1 text-[12px] font-semibold text-[#0F5E99] ${className}`} data-id="element-116" data-mp="2oce0k44tjl59">
      {label}
    </span>;
}
export function DateRead({
  date,
  minutes,
  className = ''
}: {
  date: string;
  minutes: number;
  className?: string;
}) {
  return <p className={`text-[13px] text-ink-muted ${className}`} data-id="element-117" data-mp="32blzcvx2kr8x">
      <time data-id="element-118" data-mp="32a2jv7j8mk87">{date}</time>
      <span aria-hidden="true" data-id="element-119" data-mp="37bi44xdlcmpj"> · </span>
      {minutes} min read
    </p>;
}